import queryString from 'query-string'
import React from 'react'
import { useLocation } from 'react-router-dom'
import BackButton from '../../../../../components/BackButton'
import DetailedCards from '../../../../../pages/Professionals/Dashboard/components/DetailedCards'
import { functionalitiesHelper } from '../../../../../utils/functionalitiesHelper'
import { useSchedulingDetails } from '../hooks/useSchedulingDetails'
import StatusDetailCard from './components/StatusDetailCard'
import { organizeDataByDetailedStatus } from './constants'

const StatusDetails = () => {
  const { search } = useLocation()
  const { getDates } = functionalitiesHelper
  const { date, sameDate } = queryString.parse(search, { parseBooleans: true })
  const { monthAndYear, day, fullDate } = getDates(date)
  const { professional } = JSON.parse(localStorage.getItem('userData'))
  const statusData = useSchedulingDetails(professional.id, fullDate, true, sameDate)
  const statusDetails = statusData ? organizeDataByDetailedStatus(statusData) : []
  const loading = statusDetails.length === 0
  const detailsBody = {
    title: monthAndYear,
    subtitle: `Informações até o dia ${day} ${sameDate ? 'deste mês' : ''}`,
    details: statusDetails.map((status, index) => <StatusDetailCard key={index} statusData={status} />),
    skeletonCards: 5,
    loading
  }

  return (
    <>
      <BackButton text='Detalhes dos status' />
      <DetailedCards {...detailsBody} />
    </>
  )
}

export default StatusDetails
